import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const createUser = ({
  email, password, isTemporary = false, isAdmin = false 
}) => {
  const body = JSON.stringify({
    email,
    password,
    require_reset: isTemporary,
    roles: isAdmin ? ['admin'] : [],
  })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/users/invite', fetchOptions)
}

export default createUser;
